// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uk-0";